import { Attachment, Translations, UUID } from '@/types/types';
import { ApiQueryKey } from '@/configs/apiQueryKey';
import { ProductColor } from './ProductColorApi';
import { PowerSupply } from './PowerSupplyApi';
import EntityApi, { BaseEntity } from './EntityApi';

export enum AccessoryType {
	LAMP = 'LAMP',
	POWER = 'POWER',
}

export interface Accessory extends BaseEntity {
	name: string;
	code: string;
	accessoryType: AccessoryType;
	description: string;
	price: number;
	powerProvided: number;
	powerConsumed: number;
	image: Attachment | null;
	productColor?: ProductColor;
	productColorId?: UUID;
	powerSupply?: PowerSupply | null;
	powerSupplyId?: UUID | null;
	listOrder: number;
	translations: Translations<{
		name: string;
		description: string;
	}>;
}

class AccessoryApi extends EntityApi<Accessory> {
	constructor() {
		super(ApiQueryKey.accessories);
	}
}

export default new AccessoryApi();
